
import {
    ADD_LEAD_VEHICLE,
    ADD_LEAD_VEHICLE_SUCCESS,
    ADD_LEAD_VEHICLE_ERROR,
    UPDATE_LEAD_VEHICLE,
    UPDATE_LEAD_VEHICLE_SUCCESS,
    UPDATE_LEAD_VEHICLE_ERROR,
    DELETE_LEAD_VEHICLE,
    DELETE_LEAD_VEHICLE_SUCCESS,
    DELETE_LEAD_VEHICLE_ERROR,

} from "./actionTypes"
export const addLeadVehicle = payload => {
    return {
        type: ADD_LEAD_VEHICLE,
        payload: payload,
    }
}

export const addLeadVehicleSuccess = lead => {
    return {
        type: ADD_LEAD_VEHICLE_SUCCESS,
        payload: lead,
    }
}

export const addLeadVehicleError = error => {
    return {
        type: ADD_LEAD_VEHICLE_ERROR,
        payload: error,
    }
}

export const updateLeadVehicle = payload => {
    return {
        type: UPDATE_LEAD_VEHICLE,
        payload: payload,
    }
}

export const updateLeadVehicleSuccess = lead => {
    return {
        type: UPDATE_LEAD_VEHICLE_SUCCESS,
        payload: lead,
    }
}

export const updateLeadVehicleError = error => {
    return {
        type: UPDATE_LEAD_VEHICLE_ERROR,
        payload: error,
    }
}

export const deleteLeadVehicle = payload => {
    return {
        type: DELETE_LEAD_VEHICLE,
        payload: payload,
    }
}

export const deleteLeadVehicleSuccess = lead => {
    return {
        type: DELETE_LEAD_VEHICLE_SUCCESS,
        payload: lead,
    }
}

export const deleteLeadVehicleError = error => {
    return {
        type: DELETE_LEAD_VEHICLE_ERROR,
        payload: error,
    }
}

  //Lead Vehicles//